module.exports = __webpack_public_path__ + "static/img/KKBOX.8c324723.png";